export enum EnTipoEnvio {
    Email = 0,
    WhatsApp = 1
}

export interface ParticipanteExternoAtivo {
    mensagemId: number;
    mensagemGuid: string;
    canalId: number;
    tipoCanalId: number;
    participanteEndereco: string;
    participanteId: number;
    recursoIdSistema: number;
    recursoNomeSistema: string;
}